import React, { FC, memo } from 'react'

import { ChannelImage } from '@/components/ChannelImage/ChannelImage'
import { EventHeading } from '@/components/EventHeading/EventHeading'
import { eventStatus } from '@/constants/common'
import { EventImage } from '@/containers/EventDetailPage/EventImage'
import { useFindNearestByImgWidth } from '@/hooks/useFindNearestByImgWidth'
import { usePPVPopupStore } from '@/store/usePPVPopupStore'

import {
  BodyText,
  BodyTextWrapper,
  ChannelLogo,
  ContentContainer,
  ImageBoxWrapper,
  InfoBox,
} from './styles'

const PPVEventInfoRaw: FC<{
  currentEventStatus: Nullable<eventStatus>
}> = ({ currentEventStatus }) => {
  const ppvPopup = usePPVPopupStore((state) => state.ppvPopup)
  const { event } = ppvPopup || {}

  const eventImg = useFindNearestByImgWidth(event?.image?.sources, 786, {
    targetAspectRatio: '16/9',
  })

  const eventDescription = event?.description?.long || event?.description?.short
  const channelLogoSources = event?.channelLogo?.sources

  return (
    <ContentContainer>
      <ImageBoxWrapper>
        {!!(eventImg?.url && event?.name) && (
          <EventImage src={eventImg?.url} withCover={true} />
        )}
        <ChannelLogo>
          <ChannelImage sources={channelLogoSources} />
        </ChannelLogo>
      </ImageBoxWrapper>
      <InfoBox>
        <EventHeading currentEventStatus={currentEventStatus} />
        <BodyTextWrapper>
          <BodyText>{eventDescription}</BodyText>
        </BodyTextWrapper>
      </InfoBox>
    </ContentContainer>
  )
}

export const PPVEventInfo = memo(PPVEventInfoRaw)
